module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		usage: 'management',
		resourceConnected: false,
	},

	model: {
		forwardFilterChanges: false,
		forceViewChange: false
	},

	events: {
		refresh: {
			type: 'click',
			selector: 'button[data-field-type="refresh"]',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				if(event.data.component.model.entityTable){
					event.data.component.model.entityTable.refreshData();
				}
			}
		}
	},

	methods: {
		onChange: function(isRelationChange, changeDone, fieldData){
			if(this.model.forwardFilterChanges && this.model.entityTable){
				var data = (this.model.dirtyFields || {}).data || {};
				var attributes = data.attributes || {};

				this.model.entityTable.onFilterChanged(
					attributes,
					isRelationChange ? !(fieldData || {}).isLastRelationElement : false,
					isRelationChange ? (fieldData || {}).isLastRelationElement : false
				);
			}
		},
		submit: function(){}
	},

	hooks: {
		_attach: function($element, options){
			if(!this.model.controller){
				this.closest('templates_livecom_members_controller', controller => {
					this.model.controller = controller;
				});
			}
			if(!this.model.entityTable && this.model.controller){
				this.model.controller.find('templates_livecom_members_table', table => {
					this.model.entityTable = table;
				});
			}

			this.model.forwardFilterChanges = true;
			if(this.config.usage === 'selection' || Object.keys(((this.model.dirtyFields || {}).data || {}).attributes || {}).length > 0){
				this.model.forceViewChange = true;
				this.onChange();
				this.model.forceViewChange = false;
			}
		}
	}
}